<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading
        :active="loading || loadingSesion"
        :can-cancel="false"
        :is-full-page="true"
    ></loading>
    <Header v-if="vistaCompleta" />

    <div style="width: 100%; height: auto">
        <div class="grid-contenido-central">
          <div class="justify-content-center">
            <b-card class="bCardGlobalXXL">

              <div class="row">
                <div class="col-12 justify-content-around ">
                  <div
                  id="card-info-px"
                          class="borde-azul-simple pb-0"
                    style="
                    
                      box-shadow: rgba(0, 0, 0, 0.1) 0px 20px 25px -5px,
                        rgba(0, 0, 0, 0.04) 0px 10px 10px -5px;
                      color: #565656;
                      border-radius: 20px;
                    "
                  >
                  <div class="container-fluid p-1" style="width: 100%; margin-left: 1%;" >

                      <b-row class="rowDatoPaciente " style="width: 100%;" cols-sm>

                        <b-col class="columna-img-px" style="">

                          <b-row >
                            <b-col cols="12"  >
                              <template v-if="patInfo !== undefined && patInfo.idSexo !== undefined && patInfo.idSexo < 3">
                                
                                  <img alt="img" style="margin-left: 2%;" v-if="patInfo.idSexo===1" width="125px" src="../assets/paciente/paciente.png" />
                                  <img alt="img" v-if="patInfo.idSexo===2" width="125px" src="../assets/paciente/paciente2.png" />
                                
                                </template>
                                
                               
                              <img alt="img" v-else width="120px" src="../assets/paciente/paciente3.png" />
                            </b-col>

                            <b-col cols="12">

                              <div class="d-flex justify-content-center">
                                <router-link :to="{ name: 'ScheduleNuevo'}" >
                                  <div class="botonPaciente mr-2">
                                    <img alt="calendar" class="image"  src="../assets/paciente/boton-calendario.png" />
                                  </div>
                                </router-link>

                                <div class="botonPaciente" @click="mostrarPacientesRelacionados">
                                  <img alt="calendar" class="image" src="../assets/paciente/boton-parentezco.png" />
                                </div>
                              </div>
                            </b-col>

                          </b-row>

                        </b-col>

                        <b-col class="columna-info-paciente" style="">
                          <b-row class="rowDatoPaciente">

                            <b-col cols="12">
                              <div class="nombreCompletoPaciente">{{ patInfo.nombreCompleto }}</div>
                            </b-col>

                            <b-col cols="12">
                              <div class="titulo-idPaciente">{{ patInfo.idPaciente }}</div>
                            </b-col>

                            <b-col cols="12">
                              <div v-if="
                                  patInfo.telefonoCelular !== undefined &&
                                  patInfo.telefonoCelular !== null &&
                                  patInfo.telefonoCelular !== 'null'">
                                  <b-row style="padding-left: 15px;">
                                    <img alt="img" class="iconoDecoracionRegular" src="../assets/paciente/icon-telefono.png" v-b-tooltip.hover title="Telefono"/>
                                    
                                    <strong>{{ patInfo.telefonoCelular }}</strong>
                                    <div  style="padding: 0%;" v-if="patInfo.telefonoCasa !== 'null'">
                                      , ({{ patInfo.telefonoCasa }})
                                    </div>
                                    <div  style="padding: 0%;" v-if="patInfo.telefonoTrabajo !== 'null'">
                                      , ({{ patInfo.telefonoTrabajo }})
                                    </div>
                                  </b-row>

                              </div>
                              <div v-else>Sin télefono registrado</div>
                            </b-col>

                            <b-col cols="12">
                              <div v-if="patInfo.correo !== undefined &&
                                    patInfo.correo !== null &&
                                    patInfo.correo !== 'null'" >
                                <img alt="img" class="iconoDecoracionRegular" src="../assets/paciente/icon-mail.png" v-b-tooltip.hover title="Correo"/>
                                {{ patInfo.correo }}
                              </div>
                              <div v-else>Sin correo registrado</div>
                            </b-col>

                            <b-col cols="12">
                              <div>
                                <img alt="img" class="iconoDecoracionRegular" src="../assets/paciente/icon-cumple.png" v-b-tooltip.hover title="Cumpleaños"/>
                                {{ patInfo.fechaNacimientoCompleta }}
                              </div>
                            </b-col>

                          </b-row>
                        </b-col>

                        <b-col class="columna-dinero" style="">
                          <b-row class="rowDatoPaciente">

                            
                            <b-col cols="12">
                              <div>
                                <img alt="img" class="iconoDecoracion" src="../assets/paciente/icon-diente.png" v-b-tooltip.hover title="AVPTX"/>
                                AvPTx: {{patInfo.indicador1}} %
                              </div>
                            </b-col>

                            <b-col cols="12">
                              <b-row>
                                <b-col cols="12">
                                  <div class="justify-content-center">
                                    <img alt="img" class="iconoDecoracion" src="../assets/paciente/icon-grafica.png" v-b-tooltip.hover title="Arpu"/>
                                    {{patInfo.indicador2}}
                                  </div>
                                </b-col>
                               
                              </b-row>
                            </b-col>

                            <b-col cols="12">
                              <b-row>
                                <b-col cols="12">
                                  <div class="justify-content-center">
                                    <img alt="img" class="iconoDecoracion" src="../assets/paciente/icon-dinero.png" v-b-tooltip.hover title="Ingresos del Paciente"/>
                                    {{patInfo.indicador3 | monedaSinDecimal}}
                                  </div>

                                  
                                </b-col>
                                
                              </b-row>
                            </b-col>

                            <b-col cols="12">
                              <b-row>
                                <b-col cols="12">
                                  <div class="justify-content-center">
                                    <img alt="img" class="iconoDecoracion" src="../assets/sesiones.svg" v-b-tooltip.hover title="Total Sesiones" />
                                    {{patInfo.indicador4 }}
                                  </div>

                                  
                                </b-col>
                               
                              </b-row>
                            </b-col>

                            <b-col cols="12">
                              <div>
                                <img alt="img" class="iconoDecoracion" src="../assets/paciente/icon-diente.png"/>
                                HC: {{patInfo.estatusHistorial}}
                              </div>
                            </b-col>

                            <b-col cols="12">
                              <div v-if="planesConvenios !== undefined && planesConvenios !== null && planesConvenios.length > 0">
                                <div>
                                  <a href="javascript:;" @click="showModalhistorialPlanesConvenios()">
                                    Cuenta con póliza
                                  </a>
                                </div>
                              </div>
                              <span v-else>
                                 <b-spinner type="grow" small variant="info" label="SpinningPlanes" v-if="loaderPlanes"></b-spinner>
                                Sin póliza activa
                              </span>
                            </b-col>

                            <b-col cols="12" v-if="patInfo !== undefined && planesConvenios !== undefined && planesConvenios !== null">
                              <template v-for="planc in planesConvenios"  style="display: inline-flex">
                                <div v-if="planc.aplicarDescuento && planc.registroActivoPacientePlan && planc.registroActivoPaciente && planc.registroActivoPlan" :key="planc.id">
                                  <img alt="img" style="height: 32px;" :src="'data:image/png;base64, '+planc.logoEmpresa"
                                       v-if="planc.logoEmpresa !== undefined && planc.logoEmpresa !== null && planc.logoEmpresa !== ''"
                                       @click="showModal(planc.id)"
                                       :title="planc.nombrePlan"/>
                                  <b-badge  style="cursor:pointer;max-width: 200px;text-overflow: ellipsis;overflow: hidden;" variant="primary"
                                            v-else @click="showModal(planc.id)" :title="planc.nombrePlan">{{planc.nombrePlan}}</b-badge>
                                </div>
                              </template>
                            </b-col>

                          </b-row>
                        </b-col>

                        <b-col class="columna-patient-journey" style=" ">

                          <b-row>

                            <b-col cols="12" class="mt-2">
                              <PatientJourneyV2
                                  height="100px"
                                  :desactivarTitulos="true"
                                  :idPaciente="idPaciente"
                                  :mostrar="false"
                              ></PatientJourneyV2>
                            </b-col>

                            <b-col cols="12" class="mt-3" style="padding-bottom: 5px;">
                              <div v-if="precaucionesMedicas !== undefined && precaucionesMedicas !== null && precaucionesMedicas.length > 0">
                                <div class="tituloCajaDetallePaciente" @click="mostrarPrecaucionesMedicas=!mostrarPrecaucionesMedicas">
                                  <div align="left">Precauciones médicas</div>
                                  <div class="ocultarCajaDetallePaciente">
                                    <b-icon icon="chevron-up" v-if="mostrarPrecaucionesMedicas"> </b-icon>
                                    <b-icon icon="chevron-down" v-else> </b-icon>
                                  </div>
                                </div>
                                <b-collapse v-model="mostrarPrecaucionesMedicas" >
                                    <b-list-group class="borde-rojo" style="height: 80px; overflow: auto; padding: 0px;">
                                      <b-list-group-item button v-for="prec in precaucionesMedicas" v-bind:key="prec">{{prec}}</b-list-group-item>
                                    </b-list-group>
                                </b-collapse>
                              </div>
                              <div v-else class="d-flex justify-content-center mt-3">
                                <p style="font-weight: 600;">Sin precauciones médicas</p>
                                <b-spinner type="grow" small variant="info" label="SpinningPlanes" v-if="loaderPrecMed"></b-spinner>
                              </div>
                            </b-col>
                          </b-row>

                        </b-col>

                    </b-row>
                  </div>
                  </div>
                  <b-row class="p-3 menu-tab-general" v-if="vistaCompleta">
                    <b-tabs style="width: 100%;" lazy pills>

                      <b-tab v-if="mostrarTab('nv1_PTI')" :active="selectTabM1 === 'nv1_PTI'" @click="seleccionarNv1('nv1_PTI')">
                        <template v-if="menuTexto || selected == 1" #title>
                          <span class="titulo-tab">Presupuesto SDI</span>
                        </template>

                        <template v-else #title>
                        <font-awesome-icon
                        icon="file-alt"
                        v-b-popover.hover.bottom="'Detalle PTI Presuntivo'"
                        class="colorIcons" 
                      />
                    </template>

                        <b-tabs lazy class="pl-3 pr-3">

                          <b-tab v-if="mostrarTab('nv2_AVPT')" :active="selectTabM2 === 'nv2_AVPT'" @click="seleccionarNv2('nv2_AVPT')">
                            <template #title>
                              <span class="titulo-tab">AVPTx</span>
                            </template>
                            <avptIndex :idPacienteAVPT="idPaciente" />
                          </b-tab>

                          <b-tab v-if="mostrarTab('nv2_PHV3')" :active="selectTabM2 === 'nv2_PHV3'" @click="seleccionarNv2('nv2_PHV3')">
                            <template #title>
                              <span class="titulo-tab">Presupuesto histórico v3</span>
                            </template>
                            <Presupuesto :idPaciente="idPaciente" />
                          </b-tab>

                          <b-tab v-if="mostrarTab('nv2_PHV4')" :active="selectTabM2 === 'nv2_PHV4'" @click="seleccionarNv2('nv2_PHV4')">
                            <template #title>
                              <span class="titulo-tab">Presupuesto histórico v4</span>
                            </template>
                            <PresupuestoHistoricoV4 :idPaciente="idPaciente" />
                          </b-tab>

                          <b-tab v-if="mostrarTab('nv2_RESPTI')" :active="selectTabM2 === 'nv2_RESPTI'" @click="seleccionarNv2('nv2_RESPTI')">
                            <template #title>
                              <span class="titulo-tab">Resúmen PTI</span>
                            </template>
                            <resumenPTI />
                          </b-tab>

                          <b-tab v-if="mostrarTab('nv2_BJHS')" :active="selectTabM2 === 'nv2_BJHS'" @click="seleccionarNv2('nv2_BJHS')">
                            <template #title>
                              <span class="titulo-tab">Seguimiento de PTI</span>
                            </template>
                            <HistorialBandejasPorPacienteComponente/>
                          </b-tab>

                          <b-tab v-if="mostrarTab('nv2_HDXSDI')" :active="selectTabM2 === 'nv2_HDXSDI'" @click="seleccionarNv2('nv2_HDXSDI')">
                            <template #title>
                              <span class="titulo-tab">HDx</span>
                            </template>
                            <hojasCDX :idPaciente="idPaciente" :padecimientosNino="padecimientosNino"
                                      :padecimientosAdulto="padecimientosAdulto" :padecimientosMixto="padecimientosMixto"/>
                          </b-tab>
                          <b-tab v-if="mostrarTab('nv2_DIAGINICIAL')" :active="selectTabM2 === 'nv2_DIAGINICIAL'" @click="seleccionarNv2('nv2_DIAGINICIAL')">
                            <template #title>
                              <span class="titulo-tab">Diágnostico inicial</span>
                            </template>
                            <DiagnosticoInicialPTI :paciente="patInfo" :contraerCard="true"/>
                          </b-tab>


                          <b-tab v-if="mostrarTab('nv2_HDXSDININ')" :active="selectTabM2 === 'nv2_HDXSDININ'" @click="seleccionarNv2('nv2_HDXSDININ')">
                            <template #title>
                              <span class="titulo-tab">Solicitud PTI niño</span>
                            </template>
                            <HojaDiagnosticoComponente
                                :titulo="'Solicitud de PTI niño'"
                                :subtitulo="'Diagnóstico'"
                                :codigo="'CA_03_19'"
                                :idPaciente="Number(idPaciente)"
                                :idSesionSeleccionada="Number(idSesionSeleccionada)"
                                :doctores="doctores"
                                :idDenticion="1"
                                :esSdi="true"
                                v-if="sesionIniciada"/>
                            <RedireccionarAgenda v-else />
                          </b-tab>

                          <b-tab v-if="mostrarTab('nv2_HDXSDIMIX')" :active="selectTabM2 === 'nv2_HDXSDIMIX'" @click="seleccionarNv2('nv2_HDXSDIMIX')">
                            <template #title>
                              <span class="titulo-tab">Solicitud PTI mixto</span>
                            </template>
                            <HojaDiagnosticoComponente
                                :titulo="'Solicitud de PTI  MIXTO'"
                                :subtitulo="'Diagnóstico'"
                                :codigo="'CA_03_20'"
                                :idPaciente="Number(idPaciente)"
                                :idSesionSeleccionada="Number(idSesionSeleccionada)"
                                :doctores="doctores"
                                :idDenticion="3"
                                :esSdi="true"
                                v-if="sesionIniciada"/>
                            <RedireccionarAgenda v-else />
                          </b-tab>
                          <b-tab v-if="mostrarTab('nv2_SPA')" :active="selectTabM2 === 'nv2_SPA'" @click="seleccionarNv2('nv2_SPA')">
                            <template #title>
                              <span class="titulo-tab">Solicitud PTI</span>
                            </template>
                            <HojaDiagnosticoDescentralizadoComponente
                                :titulo="'SOLICITUD DE PTI'"
                                :subtitulo="'Diagnóstico'"
                                :codigo="'CA_03_19'"
                                :idPaciente="Number(idPaciente)"
                                :idSesionSeleccionada="Number(idSesionSeleccionada)"
                                :doctores="doctores"
                                :descentralizado="false"
                                :idDenticion="2"
                                :esSdi="true"
                                v-if="sesionIniciada"/>
                            <RedireccionarAgenda v-else />
                          </b-tab>
                          <b-tab  v-if="mostrarTab('nv2_SPTDSTZD')" :active="selectTabM2 === 'nv2_SPTDSTZD'" @click="seleccionarNv2('nv2_SPTDSTZD')">
                            <template #title>
                              <span class="titulo-tab">Solicitud PTI Descentralizado</span>
                            </template>
                            <!--<HojaDiagnosticoDescentralizadoComponente
                                :titulo="'SOLICITUD DE PTI DESCENTRALIZADO'"
                                :subtitulo="'Diagnóstico'"
                                :codigo="'CA_03_19'"
                                :idPaciente="Number(idPaciente)"
                                :idSesionSeleccionada="Number(idSesionSeleccionada)"
                                :doctores="doctores"
                                :descentralizado="true"
                                :idDenticion="2"
                                :esSdi="true"
                                :existeRechazoDesentralizado="existeRechazoDesentralizado"
                                :etapaRechazo="etapaRechazo"
                                :solicitudRechazo="solicitudRechazo"
                                :vecesRechazo="vecesRechazo"
                                v-if="sesionIniciada || existeRechazoDesentralizado"/>
                            <b-button @click="this.$router.push({name: "paciente", params: {id: item.idPaciente}});"></b-button>
                            <PacienteV5
                              v-if="sesionIniciada || existeRechazoDesentralizado"
                              :idPaciente="patInfo.idPaciente" 
                              :paciente="patInfo"
                              :idSesionSeleccionada="Number(idSesionSeleccionada)"
                              :doctores="doctores"
                              :idDenticion="2"
                              :existeRechazoDesentralizado="existeRechazoDesentralizado"
                              :etapaRechazo="etapaRechazo"
                              :solicitudRechazo="solicitudRechazo"/>-->
                            <HojaDiagnostico
                              v-if="sesionIniciada || existeRechazoDesentralizado"
                              :contraerCard="true"
                              :idPaciente="patInfo.idPaciente"
                              :paciente="patInfo"
                              :idSesionSeleccionada="Number(idSesionSeleccionada)"
                              :doctores="doctores"
                              :idDenticion="2"
                              :existeRechazoDesentralizado="existeRechazoDesentralizado"
                              :idPtiRechazo = idPtiRechazo
                              :etapaRechazo="etapaRechazo"
                              :solicitudRechazo="solicitudRechazo"
                              @ptiCreado="ptiCreado"/>
                            <RedireccionarAgenda v-else />
                          </b-tab>



                            <b-tab v-if="mostrarTab('nv2_DETPTIOG')" :active="selectTabM2 === 'nv2_DETPTIOG'" @click="seleccionarNv2('nv2_DETPTIOG')">
                            <template #title>
                              <span class="titulo-tab">Detalle PTI OG</span>
                            </template>
                                <HojaDiagnosticoDescentralizadoComponente
                                        titulo="DETALLE HOJA DIAGNOSTICO OG"
                                        :subtitulo="'Diagnóstico'"
                                        :codigo="'CA_03_19'"
                                        :id-paciente="idPaciente"
                                        :id-denticion="2"
                                        detalle
                                >
                                </HojaDiagnosticoDescentralizadoComponente>
                          </b-tab>

                            <b-tab v-if="mostrarTab('nv2_DTPTIACT')" :active="selectTabM2 === 'nv2_DTPTIACT'" @click="seleccionarNv2('nv2_DTPTIACT')">
                                <template #title>
                                    <span class="titulo-tab">Detalle PTI CDx</span>
                                </template>
                                <HojaDiagnosticoDescentralizadoComponente
                                        titulo="DETALLE HOJA DIAGNOSTICO CDX"
                                        :subtitulo="'Diagnóstico'"
                                        :codigo="'CA_03_19'"
                                        :id-paciente="idPaciente"
                                        :id-denticion="2"
                                        :id-pti-cdx="patInfo.idPti"
                                        detalle
                                >
                                </HojaDiagnosticoDescentralizadoComponente>
                            </b-tab>
                          <b-tab v-if="mostrarTab('nv2_IMPSNPTI')" :active="selectTabM2 === 'nv2_IMPSNPTI'" @click="seleccionarNv2('nv2_IMPSNPTI')">
                            <template #title>
                              <span class="titulo-tab">Impresión PTI</span>
                            </template>
<!--                            <ImpresionPTINuevoM2 :idPti="patInfo.idPti" :opcion="opcionSel" :origen="origen" :esVersionV2="false"></ImpresionPTINuevoM2>-->
                            <ImpresionPtiv5 :props="true" :idPtiProp="patInfo.idPti" :opcionProp="opcionSel"/>
                          </b-tab>
                          <b-tab v-if="mostrarTab('nv2_HistorialPTI')" :active="selectTabM2 === 'nv2_HistorialPTI'" @click="seleccionarNv2('nv2_HistorialPTI')">
                            <template #title>
                              <span class="titulo-tab">Historial PTI</span>
                            </template>
                            <historialPTI :propid-paciente="idPaciente" :nombrePaciente="patInfo.nombreCompleto"></historialPTI>
                          </b-tab>
                          <b-tab v-if="mostrarTab('nv2_VRSNIMPSNPTI')" :active="selectTabM2 === 'nv2_VRSNIMPSNPTI'" @click="seleccionarNv2('nv2_VRSNIMPSNPTI')">
                            <template #title>
                              <span class="titulo-tab">Consultas PTI</span>
                            </template>
                            <VersionesPTI :propid-paciente="idPaciente"> </VersionesPTI>
                          </b-tab>
                          <b-tab v-if="mostrarTab('nv2_NTSPPTI')" :active="selectTabM2 === 'nv2_NTSPPTI'" @click="seleccionarNv2('nv2_NTSPPTI')">
                            <template #title>
                              <span class="titulo-tab">Notas PTI</span>
                            </template>
                            <NotasPacientePTI :idPti="patInfo.idPti" />
                          </b-tab>

                          <b-tab v-if="mostrarTab('nv2_AJSTDGNSTC')" :active="selectTabM2 === 'nv2_AJSTDGNSTC'" @click="seleccionarNv2('nv2_AJSTDGNSTC')">
                            <template #title>
                              <span class="titulo-tab">Ajuste diagnóstico</span>
                            </template>
                            <edicionPTI :ptiId="patInfo.idPti"></edicionPTI>
                          </b-tab>

                          <!--<b-tab v-if="mostrarTab('nv2_PTIALTR')" :active="selectTabM2 === 'nv2_PTIALTR'" @click="seleccionarNv2('nv2_PTIALTR')">
                            <template #title>
                              <span class="titulo-tab">PTI alto riesgo</span>
                            </template>
                            <PacientePtiAltoRiesgoComponente />
                          </b-tab>-->

                        </b-tabs>
                      </b-tab>

                      <b-tab v-if="mostrarTab('nv1_FSDI')" :active="selectTabM1 === 'nv1_FSDI' " @click="seleccionarNv1('nv1_FSDI')">
                        <template v-if="menuTexto || selected == 1" #title>
                          <span class="titulo-tab">Presupuesto no SDI</span>
                        </template>

                        <template v-else #title>
                          <font-awesome-icon
                            icon="money-bill"
                            v-b-popover.hover.bottom="'Fuera de SDI'"
                            class="colorIcons" 
                          />
                        </template>

                        <BloqueoPti ref="blockSinSDI"
                                    @cambiarBloqueo="cambiarBloqueoSinSDI"
                                    :idPacienteProp="idPaciente"
                                    urlProp="/tratamiento_sesion"/>

                        <b-tabs lazy v-if="!bloquedoSinSDI">

                          <b-tab  v-if="mostrarTab('nv2_HDXN')" :active="selectTabM2 === 'nv2_HDXN'" @click="seleccionarNv2('nv2_HDXN')">
                            <template #title>
                              <span class="titulo-tab">Hdx niño</span>
                            </template>
                            <HojaDiagnosticoComponente
                                :titulo="'DIAGNÓSTICO NIÑO (NO ENTRA SDI)'"
                                :subtitulo="'Diagnóstico'"
                                :codigo="'CA_03_sol_nino_sinsdi'"
                                :idPaciente="Number(idPaciente)"
                                :idSesionSeleccionada="Number(idSesionSeleccionada)"
                                :doctores="doctores"
                                :idDenticion="1"
                                :esSdi="false"
                                v-if="sesionIniciada"/>
                            <RedireccionarAgenda v-else />
                          </b-tab>

                          <b-tab v-if="mostrarTab('nv2_HDXA')" :active="selectTabM2 === 'nv2_HDXA'" @click="seleccionarNv2('nv2_HDXA')">
                            <template #title>
                              <span class="titulo-tab">Hdx adulto</span>
                            </template>
                            <HojaDiagnosticoComponente
                                :titulo="'DIAGNÓSTICO ADULTO (NO ENTRA SDI)'"
                                :subtitulo="'Diagnóstico'"
                                :codigo="'CA_03_sol_adul_sinsdi'"
                                :idPaciente="Number(idPaciente)"
                                :idSesionSeleccionada="Number(idSesionSeleccionada)"
                                :doctores="doctores"
                                :idDenticion="2"
                                :esSdi="false"
                                v-if="sesionIniciada"
                            />
                            <RedireccionarAgenda v-else />
                          </b-tab>

                          <b-tab v-if="mostrarTab('nv2_HDXM')" :active="selectTabM2 === 'nv2_HDXM'" @click="seleccionarNv2('nv2_HDXM')">
                            <template #title>
                              <span class="titulo-tab">Hdx mixto</span>
                            </template>
                            <HojaDiagnosticoComponente
                                :titulo="'DIAGNÓSTICO MIXTO (NO ENTRA SDI)'"
                                :subtitulo="'Diagnóstico'"
                                :codigo="'CA_03_sol_mixto_sinsdi'"
                                :idPaciente="Number(idPaciente)"
                                :idSesionSeleccionada="Number(idSesionSeleccionada)"
                                :doctores="doctores"
                                :idDenticion="3"
                                :esSdi="false"
                                v-if="sesionIniciada"/>
                            <RedireccionarAgenda v-else />
                          </b-tab>

                          <b-tab v-if="mostrarTab('nv2_PRES')" :active="selectTabM2 === 'nv2_PRES'" @click="seleccionarNv2('nv2_PRES')">
                            <template #title>
                              <span class="titulo-tab">Presupuesto</span>
                            </template>
                              <presupuestoSinSDI
                                      :ptiId="patInfo.idPtisinSDI"
                                      :idPaciente="idPaciente"
                                      :nombreCompleto="patInfo.nombreCompleto"
                              />
                          </b-tab>

                        </b-tabs>

                      </b-tab>

                      <b-tab v-if="mostrarTab('nv1_ECE')" :active="selectTabM1 === 'nv1_ECE'" @click="seleccionarNv1('nv1_ECE')">
                        <template v-if="menuTexto || selected == 1" #title>
                          <span class="titulo-tab">ECE</span>
                        </template>

                        <template v-else #title>
                          <font-awesome-icon
                            icon="chalkboard-teacher"
                            v-b-popover.hover.top="'Expediente Clínico Electrónico'"
                            class="colorIcons" 
                          />
                        </template>

                        <b-tabs lazy>

                          <b-tab v-if="mostrarTab('nv2_HDXSDI')" :active="selectTabM2 === 'nv2_HDXSDI'" @click="seleccionarNv2('nv2_HDXSDI')">
                            <template #title>
                              <span class="titulo-tab">ECE</span>
                            </template>
                            <ExpedienteDigital :idPacienteExp="this.idPaciente"/>
                          </b-tab>

                          <b-tab v-if="mostrarTab('nv2_HTRCN')" :active="selectTabM2 === 'nv2_HTRCN'" @click="seleccionarNv2('nv2_HTRCN')">
                            <template #title>
                              <span class="titulo-tab">Historiales Clínicos</span>
                            </template>
                              <BandejaHcs v-if="tipoHc===0" :idPaciente="idPaciente"
                                          @mostrarTipoHistoriaClinica="mostrarTipoHistoriaClinica"
                              />
                            <historia-nino-v2 v-else-if="tipoHc===1"
                                              :idHistoriaClinica="idHistoriaClinica"
                                              :activarGuardar="activarGuardar"
                                              @mostrarTipoHistoriaClinica="mostrarTipoHistoriaClinica"
                            />
                              <historia-clinica-v2 v-else-if="tipoHc=== 2"
                                                   :idHistoriaClinica="idHistoriaClinica"
                                                   :activarGuardar="activarGuardar"
                                                   @mostrarTipoHistoriaClinica="mostrarTipoHistoriaClinica"
                              />
                             <historia-emergencia-v2 v-else-if="tipoHc===3"
                                                     :idHistoriaClinica="idHistoriaClinica"
                                                     :activarGuardar="activarGuardar"
                                                     @mostrarTipoHistoriaClinica="mostrarTipoHistoriaClinica"
                             />

                          </b-tab>



                          <b-tab v-if="mostrarTab('nv2_HRRDAG')" :active="selectTabM2 === 'nv2_HRRDAG'" @click="seleccionarNv2('nv2_HRRDAG')">
                            <template #title>
                              <span class="titulo-tab">Herramientas de diagnóstico</span>
                            </template>
                            <diagnosticTools />
                          </b-tab>



                          <b-tab v-if="mostrarTab('nv2_BNDJINTERC')" :active="selectTabM2 === 'nv2_BNDJINTERC'" @click="seleccionarNv2('nv2_BNDJINTERC')">
                            <template #title>
                              <span class="titulo-tab">Interconsulta</span>
                            </template>
                            <BandejaInterconsulta :idPaciente="idPaciente" />
                          </b-tab>

                          <b-tab v-if="mostrarTab('nv2_DTCCNCSD')" :active="selectTabM2 === 'nv2_DTCCNCSD'" @click="seleccionarNv2('nv2_DTCCNCSD')">
                            <template #title>
                              <span class="titulo-tab">Detección de necesidades</span>
                            </template>
                            <needsDetection />
                          </b-tab>

                          <b-tab v-if="mostrarTab('nv2_EMPAT')" :active="selectTabM2 === 'nv2_EMPAT'" @click="seleccionarNv2('nv2_EMPAT')">
                            <template #title>
                              <span class="titulo-tab">Mapa de empatía</span>
                            </template>
                            <empatia />
                          </b-tab>



                        </b-tabs>

                      </b-tab>


                      <b-tab v-if="mostrarTab('nv1_TXR')" :active="selectTabM1 === 'nv1_TXR'" @click="seleccionarNv1('nv1_TXR')">
                        <template v-if="menuTexto || selected == 1" #title>
                          <span class="titulo-tab">Tx realizados</span>
                        </template>

                        <template v-else #title>
                          <font-awesome-icon
                          icon="tooth"
                          v-b-popover.hover.bottom="'Resumen PTI'"
                          class="colorIcons" 
                        />
                        </template>


                      </b-tab>

                      <b-tab v-if="mostrarTab('nv1_CT')" :active="selectTabM1 === 'nv1_CT'" @click="seleccionarNv1('nv1_CT')">
                        <template v-if="menuTexto || selected == 1" #title>
                          <span class="titulo-tab">Historial de citas</span>
                        </template>

                        <template v-else #title>
                          <font-awesome-icon 
                          icon="calendar" 
                          v-b-popover.hover.top="'Citas'"
                          class="colorIcons" />
                        </template>

                        <b-tabs lazy>
                          <b-tab v-if="mostrarTab('nv2_HISCTS')" :active="selectTabM2 === 'nv2_HISCTS'" @click="seleccionarNv2('nv2_HISCTS')">
                            <template #title>
                              <span class="titulo-tab">Historial de citas</span>
                            </template>
                            <HistorialCirtas :paciente="idPaciente"></HistorialCirtas>
                          </b-tab>






                          <b-tab v-if="mostrarTab('nv2_HHJSBVND')" :active="selectTabM2 === 'nv2_HHJSBVND'" @click="seleccionarNv2('nv2_HHJSBVND')">
                            <template #title>
                              <span class="titulo-tab">Historial de Hojas de Bienvenida</span>
                            </template>
                            <HistorialHojasBienvenida/>
                          </b-tab>

                        </b-tabs>
                      </b-tab>

                      <b-tab v-if="mostrarTab('nv1_TX')" :active="selectTabM1 === 'nv1_TX'" @click="seleccionarNv1('nv1_TX')">
                        <template v-if="menuTexto || selected == 1" #title>
                          <span class="titulo-tab">Tratamientos</span>
                        </template>

                        <template v-else #title>
                          <font-awesome-icon
                          icon="calendar"
                          v-b-popover.hover.top="'Tratamientos'"
                          class="colorIcons" />
                        </template>

                        <b-tabs lazy>
                          <b-tab v-if="mostrarTab('nv2_TXP')" :active="selectTabM2 === 'nv2_TXP'" @click="seleccionarNv2('nv2_TXP')">
                            <template v-if="menuTexto || selected == 1" #title>
                              <span class="titulo-tab">Tx programados</span>
                            </template>
                            <tratamientosprogramados :id-paciente="idPaciente"/>
                          </b-tab>
                          <b-tab v-if="mostrarTab('nv2_HISSSNS')" :active="selectTabM2 === 'nv2_HISSSNS'" @click="seleccionarNv2('nv2_HISSSNS')">
                            <template #title>
                              <span class="titulo-tab">Sesiones realizadas</span>
                            </template>
                            <sesiones-realizadas :id-paciente="idPaciente" ></sesiones-realizadas>
                          </b-tab>

                          <b-tab v-if="mostrarTab('nv2_TXIA')" :active="selectTabM2 === 'nv2_TXIA'" @click="seleccionarNv2('nv2_TXIA')">
                            <template v-if="menuTexto || selected == 1" #title>
                              <span class="titulo-tab">Tx activar / inactivar</span>
                            </template>

                              <template v-else #title>
                                <font-awesome-icon
                                icon="history"
                                v-b-popover.hover.bottom="'Tx activar / inactivar'"
                                class="colorIcons"
                              />
                              </template>
                            <activacionTratamientos :id-paciente="idPaciente"></activacionTratamientos>
                          </b-tab>

                        </b-tabs>
                      </b-tab>

                      <b-tab v-if="mostrarTab('nv1_RCB')" :active="selectTabM1 === 'nv1_RCB'" @click="seleccionarNv1('nv1_RCB')">
                        <template v-if="menuTexto || selected == 1" #title>
                          <span class="titulo-tab">Recibos</span>
                        </template>

                         <template v-else #title>
                          <font-awesome-icon
                            icon="id-card"
                            v-b-popover.hover.top="'Recibos'"
                            class="colorIcons" 
                          />
                        </template>
                        <b-tabs lazy>

                          <b-tab v-if="mostrarTab('nv2_RCB')" :active="selectTabM2 === 'nv2_RCB'" @click="seleccionarNv2('nv2_RCB')">
                            <template #title>
                              <span class="titulo-tab">Recibos</span>
                            </template>
                            <documents :pti="patInfo.idPti" />
                          </b-tab>



                        </b-tabs>

                      </b-tab>

                      <b-tab v-if="mostrarTab('nv1_RPLCS')" :active="selectTabM1 === 'nv1_RPLCS'" @click="seleccionarNv1('nv1_RPLCS')">
                        <template v-if="menuTexto || selected == 1" #title>
                          <span class="titulo-tab">Réplicas</span>
                        </template>

                        <template v-else #title>
                          <font-awesome-icon
                            icon="reply"
                            v-b-popover.hover.bottom="'Réplicas'"
                            class="colorIcons" 
                          />
                        </template>

                        <b-tabs lazy>

                          <b-tab v-if="mostrarTab('nv2_SLCTRPLC')" :active="selectTabM2 === 'nv2_SLCTRPLC'" @click="seleccionarNv2('nv2_SLCTRPLC')">
                            <template #title>
                              <span class="titulo-tab">Solicitud de réplica</span>
                            </template>
                            <solicitud-replica-v2 :patInfo="patInfo"></solicitud-replica-v2>
                          </b-tab>

                          <b-tab v-if="mostrarTab('nv2_HTRPLC')" :active="selectTabM2 === 'nv2_HTRPLC'" @click="seleccionarNv2('nv2_HTRPLC')">
                            <template #title>
                              <span class="titulo-tab">Historial de réplicas</span>
                            </template>
                            <historiaReplica />
                          </b-tab>

                        </b-tabs>

                      </b-tab>

                      <b-tab v-if="mostrarTab('nv1_QJS')" :active="selectTabM1 === 'nv1_QJS'" @click="seleccionarNv1('nv1_QJS')">
                        <template #title>
                          <span class="titulo-tab">Quejas</span>
                        </template>
                        <quejas-paciente :idPaciente="idPaciente" :nombreCompleto="patInfo.nombreCompleto" :vistaFiltrado="false" />
                      </b-tab>


                      <b-tab v-if="mostrarTab('nv1_DFCS')" :active="selectTabM1 === 'nv1_DFCS'" @click="seleccionarNv1('nv1_DFCS')">
                        <template v-if="menuTexto || selected == 1" #title>
                          <span class="titulo-tab">Datos fiscales</span>
                        </template>

                        <template v-else #title>
                          <font-awesome-icon
                          icon="gavel"
                          v-b-popover.hover.bottom="'Datos fiscales'"
                          class="colorIcons"
                        />
                        </template>
                        <prosecutors/>
                      </b-tab>

                      <b-tab v-if="mostrarTab('BT_Cupones')" :active="selectTabM1 === 'BT_Cupones'" @click="seleccionarNv1('BT_Cupones')">
                        <template v-if="menuTexto || selected == 1" #title>
                          <span class="titulo-tab">Cupones</span>
                        </template>

                        <template v-else #title>
                          <font-awesome-icon
                              icon="flask"
                              class="colorIcons"
                              v-b-popover.hover.bottom="'Cupones'"
                          />
                        </template>
                        <cuponera :idPaciente = "idPaciente"/>
                      </b-tab>

                    </b-tabs>
                  </b-row>

                </div>
              </div>
            </b-card>
          </div>
      </div>
    </div>

    <div v-if="selectTabM1 == 'tab10M2_PSSDI'">
      <b-row class="mb-4" v-if="patInfo.idPtisinSDI === undefined" >
        <b-col class="text-center">
          <b-button variant="primary" disabled>
            <b-spinner small></b-spinner>
            Cargando...
          </b-button>
        </b-col>
      </b-row>
      <b-alert v-if="patInfo.idPtisinSDI === null" show variant="warning">Sin registros</b-alert>
      <div v-if=" patInfo.idPtisinSDI !== undefined && patInfo.idPtisinSDI !== null ">
        <presupuestoSinSDI :ptiId="patInfo.idPtisinSDI" :idPaciente="idPaciente" :nombreCompleto="patInfo.nombreCompleto"/>
      </div>
    </div>



    <b-modal v-model="mostrarModalPacientesRelacionados" size="xl" hide-footer title="Parentescos">

      <b-table responsive
          :fields="fieldsPacientesRelacionados"
          :items="pacientesRelacionados"
               empty-text="No tiene parentezcos"
               show-empty>
        <template #cell(id_paciente)="row">
          <p class="trtItem">
            <router-link :to="{ name: 'paciente', params: { id: row.item.id_paciente }}" >
              {{ row.item.id_paciente }}
            </router-link>
          </p>
        </template>
      </b-table>
    </b-modal>

    <b-modal id="planDetalle" ref="planDetalle" size="xl" hide-footer>
      <!--<detalle :empresa-actual="planInfo" v-on:regresar="hideModal()"></detalle>-->
      <detallePlan :paciente="patInfo" :empresa-actual="planInfo" v-on:regresar="hideModal()"></detallePlan>
    </b-modal>

    <b-modal
      id="historialPlanesConvenios"
      ref="historialPlanesConvenios"
      size="xl"
      hide-footer
      :title="patInfo.nombreCompleto"
    >
      <b-row>
        <b-col>
          <br />
          <b-table
            thead-tr-class="columnas"
            :items="planesConvenios"
            :fields="encabezadosPlanesPaciente"
            responsive
          >
            <template v-slot:cell(fechaBaja)="row">
              <div>
                {{ row.item.fechaBaja | formatoFechaHora }}
              </div>
            </template>
            <template v-slot:cell(inicioVigenciaPaciente)="row">
              <div>
                {{ row.item.inicioVigenciaPaciente | formatoFechaHora }}
              </div>
            </template>
            <template v-slot:cell(finvigenciaPaciente)="row">
              <div>
                {{ row.item.finvigenciaPaciente | formatoFechaHora }}
              </div>
            </template>

            <template v-slot:cell(inicioVigenciaPlan)="row">
              <div>
                {{ row.item.inicioVigenciaPlan | formatoFechaHora }}
              </div>
            </template>
            <template v-slot:cell(finvigenciaPlan)="row">
              <div>
                {{ row.item.finvigenciaPlan | formatoFechaHora }}
              </div>
            </template>

            <template v-slot:cell(fechaModificacion)="row">
              <div>
                {{ row.item.fechaModificacion | formatoFechaHora }}
              </div>
            </template>
            <template v-slot:cell(registroActivoPaciente)="row">
              <b-alert
                variant="success"
                size="sm"
                show
                v-if="row.item.registroActivoPaciente"
                >ACTIVO</b-alert
              >
              <b-alert variant="secondary" size="sm" show v-else
                >INACTIVO</b-alert
              >
            </template>
            <template v-slot:cell(registroActivoPlan)="row">
              <b-alert
                variant="success"
                size="sm"
                show
                v-if="row.item.registroActivoPlan"
                >ACTIVO</b-alert
              >
              <b-alert variant="secondary" size="sm" show v-else
                >INACTIVO</b-alert
              >
            </template>

            <template v-slot:cell(suspendidoPlan)="row">
              <b-alert
                variant="danger"
                size="sm"
                show
                v-if="row.item.suspendidoPlan"
                >SUSPENDIDO</b-alert
              >
              <b-alert variant="success" size="sm" show v-else
                >NO SUSPENDIDO</b-alert
              >
            </template>
            <template v-slot:cell(registroActivoPacientePlan)="row">
              <div v-if="row.item.registroActivoPlan == false">
                Plan Inactivo
              </div>
              <div v-else>
                <b-alert
                  variant="success"
                  size="sm"
                  show
                  v-if="row.item.registroActivoPacientePlan"
                  >ACTIVO</b-alert
                >

                <b-alert variant="danger" size="sm" show v-else
                  >INACTIVO</b-alert
                >
              </div>
            </template>
            <template v-slot:cell(vigenciaSeleccionada)="row">
              <div v-if="row.item.vigenciaSeleccionada == null">
                <b-alert variant="danger" size="sm" show
                  >Vigencia no seleccionada</b-alert
                >
              </div>
              <div v-else>
                {{ row.item.vigenciaSeleccionada }}
              </div>
            </template>
            <template v-slot:cell(aplicarDescuento)="row">
              <div v-if="row.item.vigenciaSeleccionada == null">
                <b-alert variant="danger" size="sm" show
                  >Vigencia no seleccionada</b-alert
                >
              </div>
              <div v-else>
                <b-alert
                  variant="primary"
                  size="sm"
                  show
                  v-if="row.item.aplicarDescuento"
                  >APLICAR DESCUENTOS</b-alert
                >
                <b-alert variant="warning" size="sm" show v-else
                  >NO APLICAR DESCUENTOS</b-alert
                >
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="12" md="12" sm="12" class="text-right">
          <b-button
            variant="secondary"
            @click="hideModalhistorialPlanesConvenios()"
            >Cerrar</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
//components
import Header from "../components/Header.vue";
import needsDetection from "./perfilPacientes/historialClinica/needsDetection.vue";
import Presupuesto from "./perfilPacientes/Presupuesto.vue";
import hojasCDX from "./perfilPacientes/hojasCDX.vue";
import prosecutors from "./perfilPacientes/prosecutors.vue";
import documents from "./perfilPacientes/documents.vue";
import resumenPTI from "./perfilPacientes/resumenPTI.vue";
import diagnosticTools from "./perfilPacientes/diagnosticTools.vue";
import historiaReplica from "./perfilPacientes/historiaReplica.vue";
// import detallePtiOg from "./perfilPacientes/detallePtiOg";
import empatia from "./perfilPacientes/Empatia.vue";
import edicionPTI from "./perfilPacientes/edicionPTI.vue";
import sesionesRealizadas from "@/views/Pagos/sesionesRealizadas.vue";
import SesionesRealizadas from "./Pagos/sesionesRealizadas.vue";
import tratamientosprogramados from "./Pagos/tratamientosprogramados.vue";
import presupuestoSinSDI from "./PTI/PresupuestoSinSDI.vue";
import RedireccionarAgenda from "../components/RedireccionarAgenda.vue";
import HistorialCirtas from "./Paciente/HistorialCirtas";

import detallePlan from "./Empresas/Empresas/detallePlan";
import moment from "moment";
import PresupuestoHistoricoV4 from "@/views/perfilPacientes/PresupuestoHistoricoV4";

import ExpedienteDigital from "@/views/ExpedienteDigitalPaciente/ExpedienteDigital";
import HojaDiagnosticoComponente from "../components/hojasDiagnostico/HojaDiagnosticoComponente.vue";

import NotasPacientePTI from "@/components/PTI/nuevoM2/NotasPacientePTI";

import BandejaInterconsulta from "../components/Interconsulta/BandejaInterconsulta";

import QuejasPaciente from "@/views/Garantias/GaratiasRAS/QuejasPaciente";
import activacionTratamientos from "./Pagos/activacionTratamientos.vue";
import avptIndex from "@/views/avpt/avptIndex"
import HojaDiagnosticoDescentralizadoComponente
  from "@/components/hojasDiagnostico/HojaDiagnosticoDescentralizadoComponente";
import HojaDiagnostico from "../version5/diagnostico/HojaDiagnostico.vue";

import PatientJourneyV2 from "@/components/PatientJourneyV2";
import VersionesPTI from "@/views/PTI/VersionesPTI.vue";
import BandejaHcs from "@/views/perfilPacientes/historialClinica/BandejaHcs";
import HistoriaClinicaV2 from "@/views/perfilPacientes/historialClinica/HistoriaClinicaV2";
import HistoriaNinoV2 from "@/views/perfilPacientes/historialClinica/HistoriaNinoV2";
import HistoriaEmergenciaV2 from "@/views/perfilPacientes/historialClinica/HistorialEmergenciaV2";
import Cuponera from "@/views/perfilPacientes/cuponera.vue";
import historialPTI from "@/views/historialPTI/historialPTI.vue";
import BloqueoPti from "@/components/BloqueoPti/BloqueoPti";
import ImpresionPtiv5 from "@/version5/negociacion/ImpresionPtiv5.vue";
import DiagnosticoInicialPTI from "@/components/PTI/nuevoM2/DiagnosticoInicialPTI.vue";

export default {
  name: "Paciente",
  components: {
    ImpresionPtiv5,
    BloqueoPti,
    Cuponera,
    HistoriaEmergenciaV2,
    HistoriaNinoV2,
    HistoriaClinicaV2,
    BandejaHcs,
    PatientJourneyV2,
    HojaDiagnosticoDescentralizadoComponente,
    HojaDiagnostico,
    QuejasPaciente,
    NotasPacientePTI,
    PresupuestoHistoricoV4,
    Header,
    needsDetection,
    Presupuesto,
    hojasCDX,
    prosecutors,
    sesionesRealizadas,
    documents,
    resumenPTI,
    diagnosticTools,
    empatia,
    historiaReplica,
    SesionesRealizadas,
    tratamientosprogramados,
    presupuestoSinSDI,
    RedireccionarAgenda,
    HistorialCirtas,
    detallePlan,
    edicionPTI,
    ExpedienteDigital,


    HojaDiagnosticoComponente,

    BandejaInterconsulta,
    activacionTratamientos,
    avptIndex,
    VersionesPTI,
    historialPTI,
    DiagnosticoInicialPTI
  },
  props: {
    personalizacionIconos:  {
      type: Boolean,
      default: true
    },
    vistaCompleta: {
      type: Boolean,
      default: true
    },
    propIdPaciente: Number,
    propIdSesionSeleccionada: Number
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    precaucionesMedicas: [],
    loaderPrecMed: false,
    planesConvenios: [],
    loaderPlanes: false,
    existeRechazoDesentralizado: false,
    idPtiRechazo: null,
    etapaRechazo: null,
    solicitudRechazo: null,
    vecesRechazo: 0,
    tipoHc: 0,
    idHistoriaClinica:0,
    activarGuardar: true,
    itemsTabs: [],
    mostrarPrecaucionesMedicas:true,
    showOptions: false,
    selectTabM1: "tab1M1_AVPT",
    selectTabM2: "",
    origen: "paciente",
    loading: false,
    loadingSesion: false,
  //  nivelSalud: [],
    doctores: [],
    listaPadecimientosActivosPertenecientesADientes: [],

    padecimientosNino: [],
    padecimientosAdulto: [],
    padecimientosMixto: [],
    patInfo: {},
    estatusSolicitud: 0,
    clinicas: [],
    id: 0,
    id_denticion: 0,
    colorSelected: "",
    tipoSelected: "",
    personalidadSelected: "",
    descripcion: "",
    patientColor: { id: 1, name: "Rojo", color: "#ff0000" },
    colorArray: [
      { id: 1, name: "Rojo", color: "#ff0000" },
      { id: 2, name: "Amarillo", color: "#ffff00" },
      { id: 3, name: "Azul", color: "#0000ff" },
      { id: 4, name: "Verde", color: "#008000" },
    ],
    tipoArray: [
      { id: 1, name: "Reactivo" },
      { id: 1, name: "Estético" },
      { id: 1, name: "Preventivo" },
    ],
    personalidadArray: [
      { id: 1, name: "Directa" },
      { id: 1, name: "Emotivo" },
      { id: 1, name: "Lógico" },
      { id: 1, name: "Lógico directo" },
    ],
    percent: { name: "Tratamientos", amount: 50, buffer: 0 },
    active: "four",
    first: false,
    second: false,
    third: false,
    four: false,
    five: false,
    six: false,
    token: null,
    idPaciente: null,
    idSesionSeleccionada: null,
    opcionSel: null,
    edad: null,
    sesionIniciada: false,
    idClinica: null,
    planInfo: [],
    parentesco: null,
    sesionDia: { herramientas: false },

    encabezadosPlanesPaciente: [
      {
        key: "aplicarDescuento",
        label: "Aplicar Descuento",
      },
      {
        key: "registroActivoPacientePlan",
        label: "Estatus Paciente Plan",
      },
      {
        key: "fechaBaja",
        label: "Fecha Baja Etl",
      },
      {
        key: "idPaciente",
        label: "Id Paciente",
      },
      {
        key: "registroActivoPaciente",
        label: "Estatus Paciente",
      },
      {
        key: "descripcionTipoAsegurado",
        label: "Tipo de Asegurado",
      },
      {
        key: "empresa",
        label: "Nombre Empresa",
      },
      {
        key: "nombreTipoPlan",
        label: "Tipo de Plan",
      },
      {
        key: "descripcionCobertura",
        label: "Cobertura",
      },
      {
        key: "nombrePlan",
        label: "Nombre Plan",
      },
      {
        key: "registroActivoPlan",
        label: "Estatus del Plan",
      },
      {
        key: "suspendidoPlan",
        label: "Plan suspendido",
      },
      {
        key: "numeroPoliza",
        label: "Número Póliza",
      },
      {
        key: "certificado",
        label: "Número certificado",
      },
      {
        key: "vigenciaSeleccionada",
        label: "Vigencia Seleccionada",
      },
      {
        key: "inicioVigenciaPaciente",
        label: "Fecha Inicio de vigencia Paciente",
        sortable: true,
      },
      {
        key: "finvigenciaPaciente",
        label: "Fecha Fin de vigencia Paciente",
        sortable: true,
      },
      {
        key: "inicioVigenciaPlan",
        label: "Fecha Inicio de vigencia Plan",
        sortable: true,
      },
      {
        key: "finvigenciaPlan",
        label: "Fecha Fin de vigencia Plan",
        sortable: true,
      },
      {
        key: "fechaModificacion",
        label: "Fecha Modificación",
        sortable: true,
      },
      {
        key: "nombreUsuarioModificacion",
        label: "Usuario Modificación",
      },

    ],
    fieldsPlanes: [
      {
        key: "nombrePlan",
        label: "PLAN",
      },
      {
        key: "numeroPoliza",
        label: "PÓLIZA",
      },
      {
        key: "inicioVigencia",
        label: "VIGENCIA",
      },
    ],
    verConsentimientos: null,
    windowWidth: window.innerHeight,
    success: false,
    settings: {
      suppressScrollY: false,
      suppressScrollX: false,
      wheelPropagation: false,
    },
    blnClinicaDescentralizada: false,
    menuTexto: true,
    selected: 1,
    images: [],

    mostrarModalPacientesRelacionados: false,
    pacientesRelacionados: null,
    fieldsPacientesRelacionados: [
      {
        key: "id_paciente",
        label: "ID",
      },
      {
        key: "nombre_completo",
        label: "Paciente",
      },
      {
        key: "parentezco",
        label: "Relación",
      }
    ],

    bloquedoSinSDI:true,
    bloquedoEditarPTI:true,
  }),

  //comment to commit
  async created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerPreferenciaMenu();
    //this.obtenerIdConvenios();

    this.obtenerMedidaPantalla();

    if (this.propIdPaciente !== undefined && this.propIdPaciente !== null && this.propIdPaciente > 0) {
      this.idPaciente = this.propIdPaciente;
    } else {
      this.idPaciente = Number(this.$route.params.id);
    }

    if (this.propIdSesionSeleccionada !== undefined && this.propIdSesionSeleccionada !== null && this.propIdSesionSeleccionada > 0) {
      this.idSesionSeleccionada = this.propIdSesionSeleccionada;
    } else {
      this.idSesionSeleccionada = this.$route.params.sesion;
    }

    this.idClinica = this.$localStorageService.getIdClinica();
    this.verConsentimientos = await this.vadicionActivarEceClinica();
    await this.llenarListaDetallePaciente();
    this.llenarListaClinicas();
    this.llenarListaPadecimientos();
    this.llenarListaDoctores();
    this.traerSesionActiva();
    this.onTabSelected();
    this.obtenerParentescoDelPaciente();
    this.obtenerClinicaTieneDesentralizado();
    this.existePtiRechazado();
  },
  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
  },
  methods: {    
    mostrarTipoHistoriaClinica(hc, idHc, activarGuardar){
      this.tipoHc = hc;
      this.idHistoriaClinica = idHc;
      this.activarGuardar = activarGuardar
    },
    obtenerIdConvenios(){
      /* this.patInfo.planesConvenios.map(plan => this.images.push(plan.idEmpresa)); */
    },

    obtenerPreferenciaMenu(){
      this.$http.get(this.$api + "preferenciasUsuario/obtenerPreferencia/pacientes_perfiles/menu").then((response) => {
        this.menuTexto = response.data.data;
        this.selected = this.menuTexto ? 1 : 2;
        //de momento todos los menus van a ser texto
        this.menuTexto = true;
        this.selected = 1

      });
    },

    seleccionarNv1(tab) {
      this.selectTabM1 = tab;
      this.seleccionarNv2();
    },
    seleccionarNv2(tab) {
      this.selectTabM2 = tab;
      this.tipoHc=0
    },
    mostrarTab(tab) {
      if (tab === 'nv1_PTI') {//Presupuesto SDI
        return this.$localStorageService.can('BT_Presupuesto_SDI') && this.mostrarTab('nv2_AVPT') || this.mostrarTab('nv2_PHV3') || this.mostrarTab('nv2_PHV4') || this.mostrarTab('nv2_DTPTIACT') ||
            this.mostrarTab('nv2_RESPTI') || this.mostrarTab('nv2_BJHS') || this.mostrarTab('nv2_HDXSDI') || this.mostrarTab('nv2_HDXSDIADUL') ||
            this.mostrarTab('nv2_HDXSDININ') || this.mostrarTab('nv2_HDXSDIMIX') || this.mostrarTab('nv2_SPTDSTZD') || this.mostrarTab('nv2_SPA') || this.mostrarTab('nv2_DETPTIOG') ||
            this.mostrarTab('nv2_IMPSNPTI') || this.mostrarTab('nv2_VRSNIMPSNPTI') ||
            this.mostrarTab('nv2_NTSPPTI') || this.mostrarTab('nv2_AJSTDGNSTC') || this.mostrarTab('nv2_PTIALTR');
      }

      if (tab === 'nv1_FSDI') {//>Fuera de SDI
        return this.$localStorageService.can('BT_Presupuesto_No_SDI') && this.mostrarTab('nv2_HDXN') || this.mostrarTab('nv2_HDXA') || this.mostrarTab('nv2_HDXM') || this.mostrarTab('nv2_PRES')
        && this.patInfo.idPtisinSDI != undefined;
      }

      if (tab === 'nv1_ECE') {//ECE
        return this.$localStorageService.can('BT_ECE') && this.mostrarTab('nv2_HDXSDI') || this.mostrarTab('nv2_HTRCN') || this.mostrarTab('nv2_HTRCA') || this.mostrarTab('nv2_HTRCE') ||
            this.mostrarTab('nv2_HRRDAG') || this.mostrarTab('nv2_CNSNTMTS') || this.mostrarTab('nv2_BNDJINTERC') || this.mostrarTab('nv2_DTCCNCSD') ||
            this.mostrarTab('nv2_EMPAT') || this.mostrarTab('nv2_NTEVLCN');
      }


      if (tab === 'nv1_TXR') {//Tx realizados
        return false;
      }

      if (tab === 'nv1_TX') {//Tratamientos
        return this.$localStorageService.can('BT_Tratamientos') && this.mostrarTab('nv2_HISSSNS') || this.mostrarTab('nv2_TXIA');
      }

      if (tab === 'nv1_CT') {//Citas
        return this.$localStorageService.can('BT_Historial_citas') && this.mostrarTab('nv2_HISCTS') || this.mostrarTab('nv2_HTRLRPLC') ||
            this.mostrarTab('nv2_HHJSBVND');
      }

      if (tab === 'nv1_RCB') {//Recibos
        return this.$localStorageService.can('BT_recibos') && this.mostrarTab('nv2_RCB') || this.mostrarTab('nv2_HISPGS');
      }

      if (tab === 'nv1_RPLCS') {//Réplicas
        return this.$localStorageService.can('BT_replicas_Px') && this.mostrarTab('nv2_SLCTRPLC') && this.mostrarTab('nv2_HTRPLC');
      }

      if (tab === 'nv1_QJS') {//Quejas
        return this.$localStorageService.can('Icono_01_quejas');
      }


      if (tab === 'nv1_DFCS') {//Datos fiscales
        return this.$localStorageService.can('CA_03_fiscales');
      }

      if (tab === 'BT_Cupones') {//Cuponera
        return this.$localStorageService.can('BT_Cupones');
      }

      ///////nivel 2


      if (tab === 'nv2_AVPT') {//AVPTx
        return this.$localStorageService.can('BT_03_ver_avpt');
      }

      if (tab === 'nv2_PHV3') {//Presupuesto histórico v3
        return this.$localStorageService.can('CA_03_presupuesto');
      }

      if (tab === 'nv2_PHV4') {//Presupuesto histórico v4
        return this.$localStorageService.can('CA_03_presupuesto');
      }

      if (tab === 'nv2_HistorialPTI') {//Historial PTI
        return this.$localStorageService.can('BT_Detalle_PTI');
      }
      if (tab === 'nv2_DTPTIACT') {//Detalle PTI CDx
        return this.$localStorageService.can('PT_01_pti_presuntivo') &&
            this.patInfo.idPtiActivo != null &&
            this.patInfo.idPtisinSDI == null;
      }

      if (tab === 'nv2_RESPTI') {//Resúmen PTI
        return this.$localStorageService.can('CA_03_resumen_pti');
      }

      if (tab === 'nv2_BJHS') {//Seguimiento de PTI
        return this.$localStorageService.can('BJ_historial_solicitudes');
      }

      if (tab === 'nv2_HDXSDI') {//HDx
        return this.$localStorageService.can('HX_01_Hoja_de_hallazgos')
      }

      if (tab === 'nv2_HDXSDIADUL') {//Solicitud PTI adulto
        return this.$localStorageService.can('CA_03_solicitud_pti_adul') &&
            !this.blnClinicaDescentralizada &&
            this.sesionDia.herramientas &&
            this.patInfo.edadPaciente >= 12;
      }

      if (tab === 'nv2_HDXSDININ') {//Solicitud PTI niño
        return this.$localStorageService.can('CA_03_solicitud_pti_nino') &&
            !this.blnClinicaDescentralizada &&
            this.patInfo.edadPaciente <= 6;
      }

      if (tab === 'nv2_HDXSDIMIX') {//Solicitud PTI mixto
        return this.$localStorageService.can('CA_03_solicitud_pti_mix') &&
            !this.blnClinicaDescentralizada &&
            this.patInfo.edadPaciente >= 7 &&
            this.patInfo.edadPaciente < 12;
      }

      if (tab === 'nv2_SPA') {//Solicitud PTI

        return this.$localStorageService.can('CA_03_solicitud_pti_adul') &&
            this.blnClinicaDescentralizada === false &&
            this.sesionDia.herramientas ;

      }
      if (tab === 'nv2_SPTDSTZD') {//Solicitud PTI Descentralizado
        if(this.edad > 12){
          return this.$localStorageService.can('CA_03_solicitud_pti_desen') &&
            this.blnClinicaDescentralizada &&
            this.sesionDia.herramientas ;
        }else{
          return this.$localStorageService.can('CA_03_solicitud_pti_desen') &&
            this.blnClinicaDescentralizada;
        }

      }

      if (tab === 'nv2_DETPTIOG') {//Detalle PTI OG
        return this.$localStorageService.can('PT_01_pti_descentr_01') &&
            this.blnClinicaDescentralizada &&
            this.patInfo.idPtiActivo != null &&
            this.patInfo.idPtisinSDI == null;
      }

      if (tab === 'nv2_IMPSNPTI') {//Impresión PTI
        return this.$localStorageService.can('PR_01_imprimir_presen') &&
            this.patInfo.idPti !== null &&
            this.patInfo.ptiNuevoM2 === true;
      }
      if (tab === 'nv2_VRSNIMPSNPTI') {//Consultas PTI
        return this.$localStorageService.can('PR_01_consultar_vers_PTI') &&
            this.patInfo.idPti !== null &&
            this.patInfo.idPti !== undefined;
      }

      if (tab === 'nv2_NTSPPTI') {//Notas PTI
        return this.$localStorageService.can('Notas_01_M2') &&
            this.patInfo.idPti !== null &&
            this.patInfo.idPti !== undefined;
      }

      if (tab === 'nv2_AJSTDGNSTC') {//Ajuste diagnóstico
        return this.$localStorageService.can('AD_01_ajuste_dx') &&
            this.patInfo.idPti !== null &&
            this.patInfo.idPti !== undefined;
      }

      if (tab === 'nv2_PTIALTR') {//PTI alto riesgo
        return this.$localStorageService.can('PTI_altoRiesgo_01');
      }

      if (tab === 'nv2_HDXN') {//Hdx niño
        return this.$localStorageService.can('CA_03_sol_nino_sinsdi') &&
            this.patInfo.edadPaciente <= 6;
      }

      if (tab === 'nv2_HDXA') {//Hdx adulto
        return this.$localStorageService.can('CA_03_sol_adul_sinsdi') &&
            !this.sesionDia.herramientas &&
            this.patInfo.edadPaciente >= 13;
      }

      if (tab === 'nv2_HDXM') {//Hdx mixto
        return this.$localStorageService.can('CA_03_sol_mixto_sinsdi') &&
            this.patInfo.edadPaciente >= 7 &&
            this.patInfo.edadPaciente <= 12;
      }

      if (tab === 'nv2_PRES') {//Presupuesto
        return this.$localStorageService.can('CA_03_presup_nosdi');
      }

      if (tab === 'nv2_HDXSDI') {//ECE
        return this.$localStorageService.can('ECE_01_principal');
      }

      if (tab === 'nv2_HTRCN') {//Historiales clinicos
        return this.$localStorageService.can('BT_ECE_HisticialClinico');
      }

      if (tab === 'nv2_HTRCA') {//Hc adulto
        return this.$localStorageService.can('CA_03_historia_clinica');
      }

      if (tab === 'nv2_HTRCE') {//HC emergencia
        return this.$localStorageService.can('CA_03_hist_clin_urg');
      }

      if (tab === 'nv2_HRRDAG') {//Herramientas de diagnóstico
        return this.$localStorageService.can('CA_03_herram_dx');
      }

      if (tab === 'nv2_CNSNTMTS') {//Consentimientos
        return this.$localStorageService.can('Con_01_consentimiento') &&
            this.verConsentimientos != null;
      }

      if (tab === 'nv2_BNDJINTERC') {//Interconsulta
        return this.$localStorageService.can('IC_01_intercosulta');
      }

      if (tab === 'nv2_DTCCNCSD') {//Detección de necesidades
        return this.$localStorageService.can('CA_03_detect_necesidades');
      }

      if (tab === 'nv2_EMPAT') {//Mapa de empatía
        return this.$localStorageService.can('CA_08_empatia');
      }

      if (tab === 'nv2_NTEVLCN') {//>Nota de evolución
        return this.$localStorageService.can('NE_01_nota_evoluc');
      }

      if (tab === 'nv2_HISCTS') {//Historial de citas
        return this.$localStorageService.can('CT_01_consu_citas');
      }

      if (tab === 'nv2_HTRLRPLC') {//Recetas
        return this.$localStorageService.can('Receta_01');
      }

      if (tab === 'nv2_HHJSBVND') {//Historial de Hojas de Bienvenida
        return this.$localStorageService.can('Historial_HJBienveni_01');
      }

      if (tab === 'nv2_TXP') {//Tx programados
        return this.$localStorageService.can('CA_03_tx_programados');
      }

      if (tab === 'nv2_HISSSNS') {//Sesiones realizadas
        return this.$localStorageService.can('CA_03_sesiones');
      }

      if (tab === 'nv2_TXIA') {//Tx activar / inactivar
        return this.$localStorageService.can('Tx_01_activo_inactivo');
      }

      if (tab === 'nv2_RCB') {//Recibos
        return this.$localStorageService.can('CA_03_documentos');
      }

      if (tab === 'nv2_HISPGS') {//Estado de Cuenta
        return false;
        /*return this.patInfo.idPti !== null &&
            this.patInfo.idPti !== undefined;*/
      }

      if (tab === 'nv2_SLCTRPLC') {//Solicitud de réplica
        return this.$localStorageService.can('CA_03_solic_rep');
      }

      if (tab === 'nv2_HTRPLC') {//Historial de réplicas
        return this.$localStorageService.can('CA_03_historia_rep');
      }

      if (tab === 'nv2_DIAGINICIAL') {//Diagnostico inicial OG
        return this.$localStorageService.can('BT_Diagnostico_inicial');
      }

      console.error("--------------PERMISO NO ENCONTRADO: " + tab );
      return false;
    },

    obtenerMedidaPantalla() {
      this.windowWidth = window.innerWidth;
    },
    async validacionActivaHerramientasHdx() {
      return await this.$http.get(
        this.$api + "rutaExpediente/validacionActivaHdx"
      );
    },
    async vadicionActivarEceClinica() {
      const parametros = {idClinica: this.idClinica}
      return await this.$http.post(
        this.$api +
          "catalogos/obtenerClinicasActivasECE", parametros
      );
    },
    descargar(nombre, datos) {
      const byteCharacters = atob(datos);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: "application/pdf" });

      const url = window.URL.createObjectURL(blob);
      // window.open(url);
      const link = document.createElement("a");
      link.href = url;
      link.download = nombre;
      link.click();
    },
    showMsgBoxOne() {
      const titleNodes = this.$createElement("div", {
        domProps: { innerHTML: "<b>Alerta</b>" },
      });
      const messageNodes = this.$createElement("div", {
        domProps: {
          innerHTML:
            '<div class="divModalF"><b>Desea continuar con la operación?</b>' +
            "<br></div>",
        },
      });
      this.$bvModal.msgBoxConfirm([messageNodes], {
        title: [titleNodes],
        size: "sm",
        footerClass: "p-2",
        hideHeaderClose: false,
        centered: true,
        buttonSize: "sm",
        okTitle: "Cerrar",
      });
    },

    llenarListaClinicas() {
      this.$http.get(this.$api + "catalogos/listaClinicas").then((response) => {
        this.clinicas = response.data.data;
      });
    },

    llenarListaPadecimientos() {
      var url = "catalogos/listaPadecimientosOd";

      this.$http.get(this.$api + url).then((response) => {
        this.padecimientosAdulto = response.data.data;
        this.padecimientosNino = response.data.data;
        this.padecimientosMixto = response.data.data;
      });
    },

    llenarListaDoctores() {
      const parametros = {
        idClinica: this.idClinica
      }
      this.$http
        .post(
          this.$api +
            "diagnostico/hoja/listaDoctoresClinicaAgendaDoc", parametros
        )
        .then((response) => {
          this.doctores = response.data.data;
        });
    },

    obtenerPlanesConvenios(){
      this.loaderPlanes = true;
      const params = { idPaciente: this.idPaciente }
      this.$http.post(this.$api + "paciente/perfiles/obtenerPlanesPaciente", params)
          .then((resp) => {
            this.planesConvenios = resp.data.data
            this.loaderPlanes = false;
          }).catch((error) => {
            console.error(error);
            this.loaderPlanes = false;
          }).finally(() => {
            this.loaderPlanes = false;
          })
    },

    obtenerPrecaucionesMedicasPaciente(){
      this.loaderPrecMed = true;
      const params = { idPaciente: this.idPaciente }
      this.$http.post(this.$api + "paciente/obtenerPrecaucionesMedicas", params)
          .then((resp) => {
            this.precaucionesMedicas = resp.data.data
            this.loaderPrecMed = false;
          }).catch((error) => {
            console.error(error);
            this.loaderPrecMed = false;
          }).finally(() => {
            this.loaderPrecMed = false;
          })
    },

    llenarListaDetallePaciente() {
      this.loading = true;
      this.loadingSesion = true;
      this.token = this.$session.get("token");
      const params = {
        idPaciente: this.idPaciente
      }
      this.$http
        .post(
          this.$api +
            "paciente/perfiles/obtenerDetallePaciente", params 
        )
        .then((response) => {
          if (response.status === 200) {
            response.data.data.fechaNacimiento = moment(
              response.data.data.fechaNacimiento
            )
              .utc()
              .format("DD/MM/YYYY");
            this.edad = response.data.data.edadPaciente;
            this.patInfo = response.data.data;

            /*
            Planes y convenios se va a ir a otro servicio
            this.patInfo.planesConvenios.forEach((element) => {
              element.id = element.id.toString();
            });*/
           //this.obtenerDentticion();

            if (
              this.patInfo.idPti !== undefined &&
              this.patInfo.idPti !== null
            ) {
              this.patInfo.idPti = this.patInfo.idPti.toString();
            //  this.traerNivelSalud();
              this.traerOpcionPTI();
            }

            if (
              this.patInfo.idPtisinSDI !== undefined &&
              this.patInfo.idPtisinSDI !== null
            ) {
              this.patInfo.idPtisinSDI = this.patInfo.idPtisinSDI.toString();
            }

            if (
              this.patInfo.ptisActivos != null &&
              this.patInfo.ptisActivos.length != 0
            ) {
              var ptiReciente = this.patInfo.ptisActivos.sort(
                (a, b) =>
                  new Date(b.fechaModificacion).getTime() -
                  new Date(a.fechaModificacion).getTime()
              )[0];
              this.patInfo.idPtiActivo = ptiReciente["idPti"];
              this.estatusSolicitud =
                this.patInfo.ptisActivos[0].estatusSolicitud;
            }
          }
        })
        .catch()
        .finally(()=>{
          this.loading = false;
          this.loadingSesion = false;

          this.obtenerPlanesConvenios();
          this.obtenerPrecaucionesMedicasPaciente();
        });
    },

    traerSesionActiva() {
      const i = new Date();
      i.setDate(i.getDate());
      i.setHours(0, 0, 0, 0);
      const inicio = this.$moment(i).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      const f = new Date();
      f.setHours(23, 59, 59, 999);
      const fin = this.$moment(f).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      const url = this.$api + "sesion/dia";
      const parametros = {
        idPaciente: this.idPaciente,
        idClinica: this.idClinica,
        horaInicio: inicio,
        horaFin: fin,
      };

      this.sesionDia = {
        herramientas: false,
      };

      this.$http.post(url, parametros).then((response) => {
        if (response.data.data) {
          if (
            this.idSesionSeleccionada !== undefined &&
            this.idSesionSeleccionada !== null
          ) {

            const sesionEncontrada = response.data.data.find(
              (it) => Number(it.idSesion) === Number(this.idSesionSeleccionada)
            );

            if (sesionEncontrada !== undefined) {
              this.sesionDia = sesionEncontrada;
            }
          } else {
            if (response.data.data[0] !== undefined) {
              this.sesionDia = response.data.data[0];
            }
          }

        }
      });
    },

   /* traerNivelSalud() {
      const parametros = {idPti: this.patInfo.idPti}
      const urlNivelSalud =
        this.$api + "diagnostico/obtener/nivelSalud";

      this.$http
        .post(urlNivelSalud, parametros)
        .then((response) => {
          if (response.data.data) {
            this.nivelSalud.push(response.data.data.actual);
            this.nivelSalud.push(response.data.data.sinContratar);
            this.nivelSalud.push(response.data.data.restante);
          }
        })
        .catch((error) => {
          this.showErrorNivelSalud(error);
        });
    },*/
    traerOpcionPTI() {
      const parametros = {idPti: this.patInfo.idPti}
      const url = this.$api + "diagnostico/opcion";
      this.$http.post(url, parametros).then((response) => {
        if (response.data.data) {
          this.opcionSel = response.data.data;
        }
      });
    },

    onTabSelected() {
      this.loadingSesion = true;
      this.sesionIniciada = false;
      const params = {
        idPaciente: this.idPaciente
      }
      this.$http
        .post(
          this.$api +
            "sesion/empleadoTieneSesionActivaPaciente", params  )
        .then((response) => {
          this.sesionIniciada = response.data.data;
        })
        .finally(() => {
          this.loadingSesion = false;
        });
    },
    showModal(idPlan) {

      const parametros = {idPlan: parseInt(idPlan, 10)}
      this.$http
        .post(this.$api + "empresas/detallePlan", parametros)
        .then((response) => {
          if (response.data.data) {
            this.planInfo = response.data.data;
            this.planInfo.idPlan = this.planInfo.idPlan.toString();
          }
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(() => this.$refs["planDetalle"].show());
    },
    hideModal() {
      this.$refs["planDetalle"].hide();
    },

    obtenerParentescoDelPaciente() {
      const params = {
        idPaciente: this.idPaciente
      }
      this.$http
        .post(
          this.$api +
            "paciente/perfiles/obtenerParentescoPaciente", params )
        .then((response) => {
          if (response.data.data) {
            this.parentesco = response.data.data;
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },

    showModalhistorialPlanesConvenios() {
      this.$refs["historialPlanesConvenios"].show();
    },
    hideModalhistorialPlanesConvenios() {
      this.$refs["historialPlanesConvenios"].hide();
    },
    obtenerClinicaTieneDesentralizado() {
      const parametros = {idClinica: this.idClinica}
      this.$http
          .post(
              this.$api +
              "catalogos/obtenerClinicaDesentralizado", parametros
          )
          .then((response) => {
            this.blnClinicaDescentralizada = response.data.data;
          })
    },

    mostrarPacientesRelacionados() {
      this.mostrarModalPacientesRelacionados = false;
      this.pacientesRelacionados = null;
      this.$http
          .get(
              this.$api +
              "paciente/perfiles/obtenerParentezcosPaciente?idPaciente=" +
              this.idPaciente
          )
          .then((response) => {
            this.pacientesRelacionados = response.data.data;
          }).finally(() => this.mostrarModalPacientesRelacionados = true)
    },


    existePtiRechazado() {
      const params = {
        idPaciente: this.idPaciente
      }
      this.$http
          .post(this.$api + "pti/existePtiDesentralRechazado", params)
          .then((response) => {
            this.existeRechazoDesentralizado = response.data.data.existePtiRechazo;
            this.idPtiRechazo = response.data.data.idPTI;
            this.etapaRechazo = response.data.data.etapa;
            this.solicitudRechazo = response.data.data.idSolicitud;
            this.vecesRechazo = response.data.data.vecesRechazo

             if(this.existeRechazoDesentralizado){
               this.sesionDia = {
                 herramientas: true,
               };
             }
          })
          .catch((error) => {
            console.error(
                "Error al obtener la validación de existencia rechazo de un pti del  del paciente: " +
                error
            );
          })

    },
    
    ptiCreado(){
      this.existeRechazoDesentralizado = false;
    },

    cambiarBloqueoSinSDI(bloqueo) {
      this.bloquedoSinSDI = bloqueo;
    },
    /*cambiarBloqueoEdicionPTI(bloqueo) {
      this.bloquedoEditarPTI = bloqueo;
    },*/
  },
};
</script>

<style scoped>
  .columna-img-px{
  flex-basis: 10%;
  max-width: 10%;
}
    .columna-info-paciente{
  flex-basis: 26%;
  max-width: 26%;
}

.columna-dinero{
  flex-basis: 17%;
  max-width: 17%;
}

  .columna-patient-journey{
  flex-basis: 47%;
  max-width: 47%;
}


 .button {
  display: inline-block;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: #ddd;
  margin-right: 10px;
  border: none;
  outline: none;
  cursor: pointer;
}

.button.selected {
  background-color: #61A1C9;
}

.colorIcons {
  color: rgb(54, 54, 54);
}

.button.selected .colorIcons {
  color: #fff;
}

.button:not(.selected) .colorIcons {
  color: #ccc;
}

.button.selected:focus {
  box-shadow: 0 0 0 1px #fff, 0 0 0 2px #61A1C9;
}



  .colorIcons {
    color: #61A1C9; 
  }

  .tabHover:hover {
  color: red;
}
/*  .tab-content >  .tab-pane {

border-left: 1px solid #dee2e6  !important;
border-right: 1px solid #dee2e6 !important;
border-bottom: 1px solid #dee2e6 !important;
} */

.cardPrincipal .card-body {
  padding: 0rem 1.25rem 1.25rem 1.25rem;
}

.rowDatoPaciente {
  text-align: left;
}

.rowDatoPaciente {
  text-align: left;
  font-size: 14px;
}

.nombreCompletoPaciente {
  font-size: 18px !important;
  font-weight: bold;
  color: #17A2B8;
}

.titulo-tab {
  font-weight: bold;
  font-size: 14px;
}

.titulo-idPaciente{
  font-weight: bold;
}

.iconoDecoracion {
  width: 6%;
}

.iconoDecoracionRegular {
  width: 3.8%;
}

.botonPaciente {
  width: 28px;
  cursor: pointer;
  display: inline-block;
}

.botonPaciente:hover{
  width: 30px;
  cursor: pointer;
}

.tituloCajaDetallePaciente {
  text-align: center;
  color: var(--color-dentalia);
  font-weight: bold;
  font-size: 12px;
  cursor: pointer;
}
.ocultarCajaDetallePaciente {
  float: right;
  margin-top: -20px;
}

.grid-contenido-central {
  float: left;
  width: 100%;
  padding: 1%;
}

</style>
